import { render, staticRenderFns } from "./ContractTable.vue?vue&type=template&id=2f2672e2&"
import script from "./ContractTable.vue?vue&type=script&lang=js&"
export * from "./ContractTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports